module.exports = __webpack_public_path__ + "img/section-one-bj.a01c7d0b.png";